<template>
    <div>
        <h2>
			Handelsbetingelser
		</h2>
        <p>
            Ved at benytte dig af Virksomhedens juridiske navn services og produkter accepterer du samtidig nedenstående Handelsbetingelser. Læs dem derfor grundigt.
        </p>
        <h2>
			Om Virksomheden
		</h2>
        <p>
            {{ merchant.name }}
        </p>
        <p>
            {{ merchant.vat }}
        </p>
        <p>
            {{ merchant.address }}, {{ merchant.zip }} {{ merchant.city }}
        </p>
        <p>
            {{ merchant.email }}
        </p>
        <p>
            {{ merchant.phone }}
        </p>
        <h2>
			    Almene bestemmelser
		    </h2>
        <p>
            Ved bestilling og betaling af abonnement eller produkter hos {{ merchant.name }}, (herefter kaldet Leverandøren) accepterer køber (herefter kaldet Kunden) nærværende Handelsbetingelser. Accept sker ved afkrydsning af handelsbetingelser under tilmelding/betaling/valg af produkt på Zietwing.
        </p>
        <p>
            Leverandøren har ret til at tilføje egne betingelser til disse obligatoriske Handelsbetingelser som ikke kan ændres eller til sidestilles. De gældende Handelsbetingelser accepteres af Kunden, før en aftale indgås mellem Leverandøren og Kunden. Det påhviler Kunden til enhver tid at holde sig ajour med de gældende Handelsbetingelser, hvilke er tilgængelige på Zietwing platformen, når der bestilles et produkt.
        </p>
        <p>
            Enhver tvist imellem leverandøren og kunden er underlagt Dansk lovgivning.
        </p>
        <h2>
				  Accept af abonnementsbetingelser og køb af produkter
		    </h2>
        <p>
            Ved kundens tilmelding og valg af leverandørens produkter, accepterer kunden at Leverandøren, må trække det aftalte beløb periodevis i overensstemmelse med det valgte produkt og trækningsperiode/dato. Når kunden køber abonnement/produkter gennem Leverandøren på Zietwing platformen, fornyes dette automatisk indtil kunden afmelder sig skriftligt via leverandøren, eller ved at slette abonnement/produkt via kundens brugerlogin på Zietwing platformen.
        </p>
        <p>
            Ved kundens tilmelding accepteres yderligere, at Leverandøren har ret til at ændre abonnements/produkt pris til enhver tid. Ændring i produkt varsles på til kunden på e-mail. Betaling sker løbende i henhold til forhandlerens trækningsdato, som godkendes af kunden ved accept af produkt/abonnement.
        </p>
        <h2>
		      Leverandørens ydelse
	      </h2>
        <p>
            Leverandøren leverer til kunden en nem løsning gennem Zietwing, til betaling af abonnement/produkter hos leverandøren. Systemet er tilgængeligt online og til kunden er der et login med følgende funktioner indenfor betaling:
        </p>
        <p>
            - Allerede aktiveret betalingskort kan aflæses og slettes.
        </p>
        <p>
            - Der kan skiftes til nyt betalingskort.
        </p>
        <p>
            - Der vises alle forudgående betalinger, samt fremtidige betalinger.
        </p>
        <p>
            - Der kan hentes fakturaer på alle gennemførte betalinger
        </p>
        <p>
            - Eventuelle abonnementer kan de-aktiveres/slettes.
        </p>
        <h2>
		Betalingstjeneste
	</h2>
        <p>
            Leverandøren tilbyder sine Kunder, at de kan betale abonnement/produkter online gennem Zietwing platformen, såfremt de har tilmeldt sig denne service og er blevet godkendt. Dvs. at kunderne kan betale med fx Dankort, Visa og MasterCard med mere, via Leverandørens egen betalingsaftale med betalingsinstituttet og Zietwing betalingstjenesten.
        </p>
        <p>
            Der kan betales med følgende kort:
        </p>
        <ul type="disc">
            <li>
                Dankort
            </li>
            <li>
                Visa/Dankort
            </li>
            <li>
                Visa
            </li>
            <li>
                MasterCard
            </li>
        </ul>
        <p>
            Kortnummer og udløbsdatoen finder man altid på forsiden af sit betalingskort. Kortnummer indtastes altid uden mellemrum. Kontrolcifre (CVV kode) finder man på bagsiden af sit kort og skal indtastes første gang kunden aktiverer sin bruger profil.
        </p>
        <p>
            Kunden køber ydelsen/produktet af Leverandøren og Leverandøren kan vælge at indeholde det periodevise Abonnementsgebyr, administrationsgebyr samt eventuelle indkøbte ekstra ydelser i prisen, eller vælge at dette vises særskilt. Ydermere kan leverandøren vælge hvorvidt kunden skal betale gebyret for selve kort transaktionen.
        </p>
        <h2>
		Identitet og betalingsansvar
	</h2>
        <p>
            Ved tilmelding hos Leverandøren skal kunden tiltræde med korrekte oplysninger om identitet og validering af betalingskort udføres for at sikre, at oplysninger om Kunden er sandfærdige, samt betalingskort er aktivt og har dækning for eventuelle køb.
        </p>
        <p>
            Validering foregår ved at der foretages en live autorisation på kundens kort. Ved godkendt autorisation aktiveres kundens kort som godkendt betalingsmiddel i Zietwing platformen og kan benyttes fremadrettet.
        </p>
        <p>
            Ved benyttelse af Visa dankort/dankort eller Visa og MasterCard indestår Kunden for – og er garant for – at kunden har den identitet, som dennes kunde angiver, samt at kunden ejer det betalingskort som benyttes ved køb.
        </p>
        <p>
            Såfremt der er tale om en evt. “charge back” (dvs. en kunde, som har betalt med et kreditkort og efterfølgende afviser betalingen) fra Leverandørens tredjepart (fx Nets/indløser), er Kunden ansvarlig for straks at betale det beløb, som tredjepart forlanger, uanset årsag. Kunden forsikrer, at dennes identitet er korrekt og rigtig, samt at Kunden ikke misbruger betalingskort. Såfremt at “fraud”/misbrug alligevel skulle ske, er det Kundens ansvar og pligt at tilbagebetale Leverandøren det beløb, som der er blevet gennemført, således at Leverandøren står uforandret.
        </p>
        <h2>
		      Pris og betalingsbetingelser
	      </h2>
        <p>
            Alle priserne er angivet i danske kroner og er inkl. moms. Ændringer i valutakurser, afgifter, forsikring, nettoprisindekset, fragt og indkøbsomkostninger medfører, at Leverandøren kan justere priserne, således at Leverandøren stilles uændret.
        </p>
        <p>
            Taksering/gebyrer sker i overensstemmelse med Leverandørens til enhver tid gældende gebyrer.
        </p>
        <h2>
			    Procedure for fornyelse og sletning af kortnummer
	      </h2>
        <p>
            Bliver kundens kort lukket, fordi kunden har fået et nyt eller af anden årsag, vil betaling ikke kunne gennemføres og kunden vil pr. mail blive informeret omkring manglende betaling. Ønsker kunden, at betalingen skal trækkes fra et andet betalingskort, skal kunden aktiverer det nye kort i sin brugerkonto og vælge kortet som foretrukken betalingsmiddel.
        </p>
        <h2>
		Kortindehavers ansvars- og hæftelsesforhold
	</h2>
        <p>
            Køb af abonnementer/produkter er bindende fra det øjeblik, der er foretaget betaling. Kortholder/kunde er forpligtet til at betale det fulde beløb for hele den valgte abonnementsperiode og efterfølgende abonnementshævninger, med mindre abonnementet i mellemtiden er opsagt jf. regler for fortrydelsesret og opsigelse nedenfor.
        </p>
        <h2>
		Fortrydelsesret og reklamation
	</h2>
        <p>
            Hvis kunden fortryder et allerede accepteret abonnement/køb inden for 14 dage, efter det er trådt i kraft eller varen er leveret, kan kunden få tilbagebetalt det fulde beløb. Har kunden købt en vare, løber fortrydelsesretten fra leveringstidspunktet. Har kunden købt en abonnements ydelse, løber fortrydelsesretten fra bestillingstidspunktet.
        </p>
        <p>
            Ved fortrydelse skal kunden skrive en e-mail til Leverandøren e-mailadresse og oplyse, at der ønskes at gøre brug af fortrydelsesretten. Samtidig bedes kunden oplyse nødvendige bankoplysninger (kontonummer og registreringsnummer), så leverandøren kan tilbagebetale allerede indbetalt beløb. Det er kundens ansvar at sikre at leverandør modtager fortrydelse inden fristens udløb, i henhold til ovenstående.
        </p>
        <h2>
		Opsigelse af abonnement og bindingsperiode
	</h2>
        <p>
            Kunden kan til enhver tid opsige det løbende abonnement. I så fald vil der ikke blive hævet penge fra betalingskortet før der oprettes et nyt abonnement. Et allerede igangværende abonnement vil blive hævet i henhold til leverandørens handelsbetingelser.
        </p>
        <p>
            Kunden kan opsige et allerede i igangværende abonnement i kundens brugeradgang på Zietwing platformen. Alternativt kan kunden sende en e-mail til leverandøren omkring opsigelse, hvorefter leverandøren kan de-aktiverer igangværende abonnement.
        </p>
        <p>
            Efter opsigelse forpligter Leverandøren sig ikke yderligere over for Kunden.
        </p>
        <p>
            Abonnement, som er indbetalt, refunderes ikke. Hvis en Kunde fx betaler 1,3,6 eller 12 mdr. forud, kan dette beløb ikke refunderes. Abonnementet forlænges automatisk, medmindre Kunden opsiger aftalen skriftligt. Opsigelse af abonnement sker i overensstemmelse med leverandørens handelsbetingelser overfor kunden.
        </p>
        <p>
            Såfremt der opstår tvivl om, hvorvidt et abonnement/ydelse er opsagt, skal kunden kunne bevise, at opsigelsen er sket korrekt.
        </p>
        <h2>
		Dataindsamling
	</h2>
        <p>
            Zietwing platformen indsamler løbende oplysninger om brugsadfærd, når Kunden og andre brugere anvender webside eller software. Denne dataindsamling er anonym og anvendes med det formål at optimere services og indretning af softwaren. Zietwing’s Privatlivspolitik og betingelser for Zietwing kan læses på kundens brugerprofil.
        </p>
        <h2>
		Rettigheder
	</h2>
        <p>
            Alle rettigheder omkring Zietwing platformen ejes af Zietwing, derfor Alt software, design, arkitektur, tekst o. lign. er beskyttet af ophavsretten samtidig med, at navne og egenudviklede termer er anvendte varemærker. “
        </p>
        <p>
            Enhver overtrædelse heraf vil blive retsforfulgt, og krav om betaling vil finde sted.
        </p>
        <h2>
		Misligholdelse
	</h2>
        <p>
            Al betaling fra Kunden til Leverandøren foregår som udgangspunkt ved automatisk forudbetaling eller nu og her betaling, når Kunden registrerer sit betalingskort. Såfremt betaling ikke indgår til den fastsatte forfaldsdag, vil dette kunne medføre påløb af yderligere inddrivelses omkostninger, herunder renter og rykkergebyrer, der belaster Kunden.
        </p>
        <p>
            Såfremt sagen som et led i inddrivelsen overgives til advokat, vil advokaten eller Leverandøren kunne kræve yderligere inkassoomkostninger. Ved misligholdelse af Leverandørens Handelsbetingelser kan Leverandørens opsige samarbejdet øjeblikkeligt. Leverandøren har ret til at lukke for Kundens adgang til købte produkter, såfremt betaling ikke sker rettidigt.
        </p>
        <h2>
		Ansvarsbegrænsning
	</h2>
        <p>
          Zietwing, som ejer og drifter Zietwing betalingsplatformen tager forbehold for programmeringsfejl og servernedbrud og kan aldrig holdes økonomisk ansvarlig for eventuel nedetid, samme gældende leverandøren. I tilfælde af opdatering af software eller udstyr har Zietwing ret til at lukke for adgangen i en begrænset periode, som typisk vil ske, hvor færrest mulige Kunder vil blive påvirket af det. Zietwing kan ikke holdes ansvarlig for direkte eller indirekte tab, der er sket i forbindelse med anvendelse af Zietwing software og ydelser.
        </p>
        <p>
            Det er Kundens eget ansvar at eftertjekke at alt er korrekt, når der trækkes abonnement på kundens betalingskort. Ved konstateret fejl kan kunden kontakte leverandøren på leverandørens e-mail adresse eller leverandørens tlf.nr. Eller tage direkte kontakt til Zietwing gennem e-mail info@zietwing.com
        </p>
        <p>
            Det er Kundens ansvar, at informere Leverandøren ved ændring af: adresse, telefonnummer, mailadresse, betalingskort. og andre personlige oplysninger, der måtte være tilknyttet kunden brugerkonto og som har relevans for betaling med mere.
        </p>
        <h2>
		<strong></strong>
	</h2>
        <h2>
		Betalingssikkerhed
	</h2>
        <p>
            Alle betalingskort informationer opbevares i PCI DSS level 1 sikret betalingsgateway leveret af Zietwing. Informationer på betalingskort er udelukkende tilgængelige for betalingsgatewayens personale og derved ikke tilgængeligt for leverandøren. Al håndtering af betalingskort informationer er underlagt PCI
        </p>
        <h2>
		Force Majeure
	</h2>
        <p>
          Zietwing eller leverandøren er ikke ansvarlig for tab, der skyldes force majeure, herunder sabotage, krig, terror, indbrud, strømsvigt, strejke, lockout, boykot, blokade, hærværk, vandskade, brand, røgskade, eksplosion eller andre omstændigheder som ligger uden for Zietwing eller Leverandøren kontrol.
        </p>
        <h2>
		Fortrolighedspolitik
	</h2>
        <p>
            Leverandøren forstår og respekterer vigtigheden af privatliv på internettet.
        </p>
        <p>
            Leverandøren vil ikke afsløre information om kunder/brugere til tredje part, med mindre det er nødvendigt for at implementere en transaktion eller loven foreskriver det.
        </p>
        <p>
            Leverandøren vil ikke sælge dit navn, adresse, e-mail adresse, eller personlige data til tredje part uden din forudgående tilladelse.
        </p>
        <p>
            Som registreret hos Leverandøren har du altid ret til at gøre indsigelse mod registreringen. Du har også ret til indsigt i, hvilke oplysninger der er registreret om dig. Disse rettigheder har du efter Persondataloven og henvendelse i forbindelse hermed rettes til Leverandøren på Leverandøren e-mailadresse, alternativt kan du i din brugerkonto læse Zietwing’s persondata politik og ligeledes anmode om indsigt.
        </p>

		<hr>

		<p v-html="merchant.terms"></p>
    </div>
</template>



<script>
	export default {
		name: 'PaymentTerms',

		computed: {
			merchant () {
				return this.$store.getters.activeMerchant
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/payment/PaymentTerms.vue